module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('div', {
      key: tab.name,
      staticClass: "tab",
      class: {
        'is-active': tab.name == _vm.active
      },
      on: {
        "click": function($event) {
          return _vm.changeTab(tab.name)
        }
      }
    }, [_vm._v("\n    " + _vm._s(_vm.$t(tab.code)) + "\n  ")])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ee8e774","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/Layout/PageTabs.vue
// module id = 1855
// module chunks = 0